import styled from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";
import { Paragraph } from "BaseComponents/Text";

export const DescriptionText = styled(Paragraph)`
	& {
		display: ${({ fullWidth }) => (fullWidth ? "block" : "none")};
	}
`;
export const ArticleImage = styled.div`
	min-height: 200px;
	min-width: 40%;
	flex-basis: 50%;
	width: 100%;
	display: flex;
	align-items: flex-end;
	transition: 0.2s ease;
	height: auto;
	border-top-left-radius: ${({ theme }) => theme.border.radius};
	border-top-right-radius: ${({ theme }) => theme.border.radius};
	background-size: cover;
	background-repeat: no-repeat;
	background-position: 50% center;
	background-image: ${({ Image }) => `url(${Image})`};
	${media.greaterThan(breakpoints.mobile)`
		min-height: ${({ fullWidth }) => (fullWidth ? "180px" : "140px")};
		max-height: ${({ fullWidth }) => (fullWidth ? "" : "140px")};
  `}
`;
export const DateWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;
export const ArticleBottom = styled.div`
	display: flex;
	flex-direction: column;
	padding: 1rem;
	height: auto;
`;
export const TextSpan = styled.span`
	font-size: 12px;
	display: flex;
	align-items: center;
`;
export const Square = styled.div`
	display: inline-block;
	width: 9px;
	height: 9px;
	background: ${({ theme }) => theme.colors.secondary};
	margin-right: 5px;
`;
export const H2 = styled.h2`
	${media.greaterThan(breakpoints.mobile)`
	font-size: 24px;
    line-height: 30px;
`}
	span {
		border-bottom: 2px solid transparent;
		transition: 0.2s ease;
	}
	margin: 0.5rem 0px;
	display: block;
	font-weight: bold;
	color: black;
	font-size: 20px;
	line-height: 26px;
`;
export const ArticleWrapper = styled.a.attrs(({}) => ({}))`
	margin: ${({ fullWidth }) => (fullWidth ? 0 : "8px")};
	flex-basis: ${({ fullWidth }) => (fullWidth ? 0 : "33%")};
	background-color: ${({ theme }) => theme.colors.white};
	border-radius: ${({ theme }) => theme.border.radius};
	display: flex;
	flex-direction: column;
	width: auto;
	border: 1px solid ${({ theme }) => theme.colors.grey};
	outline: none;
	transition: all 0.2s ease;
	cursor: pointer;
	${media.lessThan(breakpoints.ipad)`
	margin: ${({ fullWidth }) => (fullWidth ? 0 : " 0.5rem")};
    `}
	${media.lessThan(breakpoints.mobile)`
	margin: ${({ fullWidth }) => (fullWidth ? 0 : " 0.5rem 0rem")};

    `}

	${media.greaterThan(breakpoints.mobile)`
	flex-direction: ${({ fullWidth }) => (fullWidth ? "row" : "column")};
	min-height: 180px;
	height: auto;

        flex-grow: 1;
	max-width: ${({ fullWidth }) => (fullWidth ? "" : "50%")};

        &:first-of-type {
		margin-left: 0;
	}
	&:last-of-type {
		margin-right: 0;
	}

        flex-wrap: nowrap;
  `} &:hover, &:focus {
		& > div:first-of-type {
			opacity: 0.7;
		}

		h2 {
			span {
				transition: 0.2s ease;
				border-color: black;
			}
		}
	}
`;
